<section class="dashboard-servidor">
  <p class="dashboard-identificacao" *ngIf="identificacao">{{ identificacao }}</p>
  <div class="dashboard-grade">
    <button
      type="button"
      class="dashboard-atalho"
      *ngFor="let atalho of atalhos"
      (click)="selecionar.emit(atalho.id)">
      <span class="dashboard-icone">
        <i class="bi" [ngClass]="atalho.icone"></i>
      </span>
      <span class="dashboard-rotulo">{{ atalho.rotulo }}</span>
    </button>
  </div>
</section>
